import React from "react";
import { BtnOpenChat, ChatCell, ChatCellLabel, ChatWrapperButton, HrLine, MessageCounter } from "../index.styled";

export interface ChatIndicatorProps {
    onOpenChat: () => void;
    unreadCount?: number;
}

const ChatIndicator: React.FC<ChatIndicatorProps> = ({ onOpenChat, unreadCount = 0 }) => {
    return (
        <ChatWrapperButton>
            <ChatCell key="chat-cell">
                <ChatCellLabel>Your Swing Coach</ChatCellLabel>
                <MessageCounter>{unreadCount} New Messages</MessageCounter>
                <HrLine />
                <BtnOpenChat onClick={(e: React.MouseEvent<HTMLElement>) => { e.stopPropagation(); onOpenChat(); }} disableElevation>
                    Open With Chat
                </BtnOpenChat>
            </ChatCell>
        </ChatWrapperButton>
    );
}

export default ChatIndicator;